var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraphImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 162.99 209.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2,.cls-7{fill:none;stroke:#3ac2d7;stroke-miterlimit:10;}.cls-2{stroke-width:0.66px;}.cls-2,.cls-3,.cls-7,.cls-8{opacity:0.3;}.cls-3{mix-blend-mode:multiply;}.cls-4{fill:url(#linear-gradient);}.cls-5{fill:url(#linear-gradient-2);}.cls-6{fill:url(#linear-gradient-3);}.cls-7{stroke-width:0.48px;}.cls-9{fill:#3ac2d7;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 32.56,
    y1: 80.85,
    x2: 32.56,
    y2: 204.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4e0ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8781bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 81.44,
    y1: 63,
    x2: 81.44,
    y2: 268.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 131.55,
    y1: 63,
    x2: 131.55,
    y2: 268.9,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "StartUp_NewHome",
    "data-name": "StartUp NewHome"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 159.41,
    y1: 2.03,
    x2: 159.41,
    y2: 75.45
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 11.17,
    y: 107.91,
    width: 42.78,
    height: 102.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 60.06,
    y: 62.7,
    width: 42.78,
    height: 146.13
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 110.16,
    y: 11.02,
    width: 42.78,
    height: 197.81
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 3.45,
    y1: 103.55,
    x2: 3.45,
    y2: 208.83
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "3.58 102.09 54.35 102.09 54.35 55.52 102.78 55.52 102.78 2.32 159.41 2.32"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M7.16,102a3.58,3.58,0,1,1-3.58-3.58A3.58,3.58,0,0,1,7.16,102Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M57.8,101.87a3.58,3.58,0,1,1-3.58-3.58A3.58,3.58,0,0,1,57.8,101.87Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M57.8,55.52a3.58,3.58,0,1,1-3.58-3.58A3.58,3.58,0,0,1,57.8,55.52Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M106.34,55.52a3.58,3.58,0,1,1-3.58-3.58A3.58,3.58,0,0,1,106.34,55.52Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M106.34,4.27A3.58,3.58,0,1,1,102.76.69,3.58,3.58,0,0,1,106.34,4.27Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M162.36,3.58A3.58,3.58,0,1,1,158.78,0,3.58,3.58,0,0,1,162.36,3.58Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M163,78.84a3.58,3.58,0,1,1-3.58-3.58A3.58,3.58,0,0,1,163,78.84Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphImage);
export default __webpack_public_path__ + "static/media/graphImage.a4c53f695301fd22e13f8e1a20434b71.svg";
export { ForwardRef as ReactComponent };